const i18AssetURL = '/content/dam/mb-nafta/us/dynamic-stage/dynamic-stage-i18n.json';

export default i18AssetURL;
